import React, { FC } from 'react';
import { SVGTooltipProps } from '@utils';
import { SvgWithTooltip } from '../SvgWithTooltip';

export const Display: FC<SVGTooltipProps> = ({ onClick, divClassName, tooltip }) => (
  <SvgWithTooltip
    onClick={onClick}
    divClassName={divClassName}
    tooltip={tooltip}
  >
    <svg 
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 548.176 548.175" 
    >
      <g>
        <path d="M118.774,383.722h310.632c12.562,0,23.312-4.47,32.257-13.422c8.949-8.949,13.422-19.698,13.422-32.258V137.046
          c0-12.563-4.473-23.313-13.422-32.261c-8.945-8.947-19.694-13.418-32.257-13.418H118.774c-12.562,0-23.318,4.471-32.264,13.418
          c-8.947,8.947-13.418,19.698-13.418,32.261v200.997c0,12.56,4.471,23.312,13.418,32.258
          C95.456,379.246,106.212,383.722,118.774,383.722z M109.634,137.046c0-2.474,0.905-4.619,2.713-6.423
          c1.811-1.806,3.953-2.712,6.427-2.712h310.625c2.478,0,4.619,0.904,6.427,2.712c1.803,1.809,2.707,3.949,2.707,6.423v200.997
          c0,2.471-0.904,4.617-2.707,6.42c-1.808,1.808-3.949,2.714-6.427,2.714H118.771c-2.475,0-4.617-0.903-6.427-2.714
          c-1.805-1.81-2.71-3.949-2.71-6.42V137.046z"
        />
        <path d="M502.496,401.997H45.681H0v27.404c0,7.618,4.471,14.086,13.417,19.414c8.951,5.328,19.702,7.994,32.264,7.994h456.815
          c12.56,0,23.312-2.666,32.258-7.994s13.422-11.796,13.422-19.414v-27.404H502.496z M296.928,429.401h-45.681
          c-3.042,0-4.565-1.526-4.565-4.568c0-3.046,1.523-4.575,4.565-4.575h45.681c3.045,0,4.571,1.529,4.571,4.575
          C301.499,427.875,299.973,429.401,296.928,429.401z"
        />
      </g>
  </svg>
  </SvgWithTooltip>
);
